import { cn } from '../lib/cn';

const initials = (name: string) =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? '')
    .join('');

export const Avatar = ({ name, className }: { name: string; className?: string }) => (
  <span
    aria-hidden
    className={cn(
      'flex size-avatar shrink-0 items-center justify-center rounded-full bg-border-raised',
      'text-micro font-semibold text-primary',
      className,
    )}
  >
    {initials(name)}
  </span>
);
